import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { ServiceService } from '../../service.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-view-leave-request',
  templateUrl: './view-leave-request.component.html',
  styleUrls: ['./view-leave-request.component.css']
})
export class ViewLeaveRequestComponent implements OnInit {
  
  private routerSub!: Subscription;
  
  useType: boolean = false;
  output: any[] = [];
  employeeDropdown: any[] = [];
  loaderShown = true;
  tableShown = false;

  // ── Stats ──
  pendingCount = 0;
  approvedCount = 0;
  rejectedCount = 0;
  preApprovedCount = 0;
  totalCount = 0;

  // ── Bulk selection ──
  selectedRequests: Set<string> = new Set();
  selectAll = false;

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Pre approved', value: 'Pre approved' },
    { label: 'Approved', value: 'Approved' },
    { label: 'Rejected', value: 'Rejected' },
  ];

  leaveTypeOptions = [
    { label: 'All', value: '' },
    { label: 'Sick Leave', value: 'Sick Leave' },
    { label: 'Local Leave', value: 'Local Leave' },
    { label: 'Vacation Leave', value: 'Vacation Leave' },
    { label: 'Emergency Leave', value: 'Emergency Leave' },
    { label: 'Official Trip', value: 'Official Trip' },
    { label: 'Compassionate Leave', value: 'Compassionate Leave' },
  ];

  private pipe = new DatePipe('en-US');

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });

  constructor(
    private service: ServiceService,
    private router: Router
  ) {
    const userType = localStorage.getItem('userTypecon');
    this.useType = userType === 'Admin' || userType === 'Hr_Manager';

    // ── Listen for navigation BEFORE it happens ──
    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe((event: any) => {
      const goingToDetail = event.url.includes('Leave-request-detail');
      if (!goingToDetail) {
        // Going to another module — reset the filter state
        this.service.resetLeaveFilterState();
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }

  ngOnInit(): void {
    this.fetchEmployees();
    this.fetchData();
  }

  fetchEmployees(): void {
    this.service.ViewAllEmployeefilter('').subscribe({
      next: (res) => {
        this.employeeDropdown = res.data || [];
      },
      error: () => {
        this.employeeDropdown = [];
      }
    });
  }

  onEmployeeChange(_event: any): void {
    // Just updates the model, user clicks Apply to fetch
  }

  onPageChange(page: number): void {
    this.New_count = page - 1;
    this.count = page - 1;
    this.fetchData();
  }

  pagenumber: any = [
    { value: 20, viewValue: 20 },
    { value: 40, viewValue: 40 },
    { value: 60, viewValue: 60 },
    { value: 80, viewValue: 80 },
    { value: 100, viewValue: 100 },
  ];

  // ── Single API call — stats calculated from same response ──────────────────
  fetchData(): void {
    this.loaderShown = false;
    this.tableShown = true;

    setTimeout(() => {
      const el = document.querySelector('.leave-scrollable-content');
      if (el) el.scrollTop = this.service.leaveFilterState.scrollTop;
    }, 50);

    // ── Call 1: Table data — limit 20, fast ──
    this.service.viewLeaveRequest(
      this.count,
      this.filterStatus,
      this.filterLeaveType,
      this.filterFromDate,
      this.filterToDate,
      this.filterEmployeeId,
      this.limit
    ).subscribe({
      next: (res) => {
        this.output = res.data || [];

        // ── Read counts directly from response ──
        const c = res.counts;
        if (c) {
          this.pendingCount = c.total_pending || 0;
          this.approvedCount = c.total_approved || 0;
          this.rejectedCount = c.total_rejected || 0;
          this.preApprovedCount = c.total_pre_approved || 0;
          this.totalCount = c.total_requests || 0;
        }

        this.loaderShown = false;
        this.tableShown = true;
      },
      error: () => {
        this.loaderShown = false;
        this.Toast.fire({ icon: 'error', title: 'Failed to load leave requests' });
      }
    });
  }

  get filterStatus() { return this.service.leaveFilterState.filterStatus; }
  set filterStatus(v: string) { this.service.leaveFilterState.filterStatus = v; }

  get filterLeaveType() { return this.service.leaveFilterState.filterLeaveType; }
  set filterLeaveType(v: string) { this.service.leaveFilterState.filterLeaveType = v; }

  get filterFromDate() { return this.service.leaveFilterState.filterFromDate; }
  set filterFromDate(v: string) { this.service.leaveFilterState.filterFromDate = v; }

  get filterToDate() { return this.service.leaveFilterState.filterToDate; }
  set filterToDate(v: string) { this.service.leaveFilterState.filterToDate = v; }

  get filterEmployeeId() { return this.service.leaveFilterState.filterEmployeeId; }
  set filterEmployeeId(v: string) { this.service.leaveFilterState.filterEmployeeId = v; }

  get count() { return this.service.leaveFilterState.count; }
  set count(v: number) { this.service.leaveFilterState.count = v; }

  get New_count() { return this.service.leaveFilterState.New_count; }
  set New_count(v: number) { this.service.leaveFilterState.New_count = v; }

  get limit() { return this.service.leaveFilterState.limit; }
  set limit(v: number) { this.service.leaveFilterState.limit = v; }

  // ── Filters ────────────────────────────────────────────────────────────────
  onFilterChange(_event: any): void {
    // If from_date is set but to_date is empty, default to_date to today
    if (this.filterFromDate && !this.filterToDate) {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const yyyy = today.getFullYear();
      this.filterToDate = `${yyyy}-${mm}-${dd}`;
    }

    // If to_date is set but from_date is empty, default from_date to same as to_date
    if (this.filterToDate && !this.filterFromDate) {
      this.filterFromDate = this.filterToDate;
    }

    this.count = 0;
    this.New_count = 0;
    this.clearSelection();
    this.fetchData();
  }

  clearFilters(): void {
    this.filterStatus = '';
    this.filterLeaveType = '';
    this.filterFromDate = '';
    this.filterToDate = '';
    this.filterEmployeeId = '';
    this.onFilterChange(null);
  }

  // ── Selection ──────────────────────────────────────────────────────────────
  toggleSelection(id: string, event: any): void {
    const item = this.output.find(c => c._id === id);
    if (!item || (item.status !== 'Pending' && item.status !== 'Pre approved')) {
      event.target.checked = false;
      return;
    }
    event.target.checked
      ? this.selectedRequests.add(id)
      : this.selectedRequests.delete(id);

    this.selectAll = this.output
      .filter(i => i.status === 'Pending' || i.status === 'Pre approved')
      .every(i => this.selectedRequests.has(i._id));
  }

  toggleSelectAll(event: any): void {
    this.selectedRequests.clear();
    if (event.target.checked) {
      this.output
        .filter(i => i.status === 'Pending' || i.status === 'Pre approved')
        .forEach(i => this.selectedRequests.add(i._id));
    }
    this.selectAll = event.target.checked;
  }

  applyFilters(): void {
    this.count = 0;
    this.New_count = 0;
    this.clearSelection();
    this.fetchData();
  }

  get hasPendingRows(): boolean {
    return this.output.some(c => c.status === 'Pending' || c.status === 'Pre approved');
  }

  preApprove(record: any): void {
    Swal.fire({
      title: 'Pre-Approve Leave Request?',
      text: `Pre-approve leave for ${record.employee_name}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#7b5ea7',
      confirmButtonText: 'Yes, Pre-Approve',
    }).then(result => {
      if (!result.isConfirmed) return;

      Swal.fire({ title: 'Processing...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      const body = {
        _id: record._id,
        status: 'Pre approved',
        approved_by_id: localStorage.getItem('admin_id') || ''
      };

      this.service.updateLeaveRequest(body).subscribe({
        next: (res: any) => {
          Swal.close();
          if (res.success) {
            this.Toast.fire({ icon: 'success', title: 'Leave request pre-approved!' });
            this.fetchData();
          } else {
            this.Toast.fire({ icon: 'error', title: res.message || 'Failed to pre-approve' });
          }
        },
        error: () => {
          Swal.close();
          this.Toast.fire({ icon: 'error', title: 'Error pre-approving request' });
        }
      });
    });
  }

  setStatusFilter(status: string): void {
    this.filterStatus = status;
    this.count = 0;
    this.New_count = 0;
    this.clearSelection();
    this.fetchData();
  }

  isSelected(id: string): boolean { return this.selectedRequests.has(id); }

  clearSelection(): void {
    this.selectedRequests.clear();
    this.selectAll = false;
  }

  onRowClick(record: any): void {
    this.service.leaveFilterState.scrollTop =
      document.querySelector('.leave-scrollable-content')?.scrollTop || 0;
    this.router.navigate(['/admin/Leave-request-detail'], {
      queryParams: { id: record._id }
    });
  }

  // ── Approve single ─────────────────────────────────────────────────────────
  approve(record: any): void {
    Swal.fire({
      title: 'Approve Leave Request?',
      text: `Approve leave for ${record.employee_name}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#09a109',
      confirmButtonText: 'Yes, Approve',
    }).then(result => {
      if (!result.isConfirmed) return;

      Swal.fire({ title: 'Approving...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      const body = {
        _id: record._id,
        status: 'Approved',
        approved_by_id: localStorage.getItem('admin_id') || ''
      };

      this.service.updateLeaveRequest(body).subscribe({
        next: (res) => {
          Swal.close();
          if (res.success) {
            this.Toast.fire({ icon: 'success', title: 'Leave request approved!' });
            this.selectedRequests.delete(record._id);
            this.fetchData();
          } else {
            this.Toast.fire({ icon: 'error', title: res.message || 'Failed to approve' });
          }
        },
        error: () => {
          Swal.close();
          this.Toast.fire({ icon: 'error', title: 'Error approving request' });
        }
      });
    });
  }

  // ── Reject single ──────────────────────────────────────────────────────────
  reject(record: any): void {
    Swal.fire({
      title: 'Reject Leave Request',
      input: 'textarea',
      inputLabel: 'Reason for rejection',
      inputPlaceholder: 'Enter rejection reason...',
      showCancelButton: true,
      confirmButtonText: 'Reject',
      confirmButtonColor: '#e53935',
      inputValidator: (v) => !v ? 'Rejection reason is required!' : null
    }).then(result => {
      if (!result.isConfirmed || !result.value) return;

      Swal.fire({ title: 'Rejecting...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      const body = {
        _id: record._id,
        status: 'Rejected',
        reject_reason: result.value,
        approved_by_id: localStorage.getItem('admin_id') || ''
      };

      this.service.updateLeaveRequest(body).subscribe({
        next: (res) => {
          Swal.close();
          if (res.success) {
            this.Toast.fire({ icon: 'success', title: 'Leave request rejected.' });
            this.fetchData();
          } else {
            this.Toast.fire({ icon: 'error', title: res.message || 'Failed to reject' });
          }
        },
        error: () => {
          Swal.close();
          this.Toast.fire({ icon: 'error', title: 'Error rejecting request' });
        }
      });
    });
  }

  // ── Bulk approve ───────────────────────────────────────────────────────────
  approveSelected(): void {
    if (this.selectedRequests.size === 0) {
      this.Toast.fire({ icon: 'warning', title: 'Please select at least one request' });
      return;
    }

    Swal.fire({
      title: `Approve ${this.selectedRequests.size} request(s)?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#09a109',
      confirmButtonText: 'Yes, Approve All',
    }).then(result => {
      if (!result.isConfirmed) return;

      Swal.fire({ title: 'Processing...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      const body = {
        leave_ids: Array.from(this.selectedRequests),
        status: 'Approved',
        approved_by_id: localStorage.getItem('admin_id') || ''
      };

      this.service.bulkUpdateLeaveRequest(body).subscribe({
        next: (res) => {
          Swal.close();
          if (res.success) {
            const n = this.selectedRequests.size;
            this.Toast.fire({ icon: 'success', title: `${n} request${n > 1 ? 's' : ''} approved!` });
            this.clearSelection();
            this.fetchData();
          } else {
            this.Toast.fire({ icon: 'error', title: res.message || 'Bulk approval failed' });
          }
        },
        error: () => {
          Swal.close();
          this.Toast.fire({ icon: 'error', title: 'Error during bulk approval' });
        }
      });
    });
  }

  // ── Pagination ─────────────────────────────────────────────────────────────
  clicksPrevious(): void {
    if (this.New_count === 0) return;
    this.New_count--;
    this.count = this.New_count;
    this.fetchData();
  }

  clicksNext(): void {
    const next = this.count + 1;
    this.service.viewLeaveRequest(
      next,
      this.filterStatus,
      this.filterLeaveType,
      this.filterFromDate,
      this.filterToDate,
      this.filterEmployeeId,
      this.limit
    ).subscribe(res => {
      if ((res.data || []).length > 0) {
        this.count = next;
        this.New_count = next;
        this.output = res.data;
      }
    });
  }

  limitChange(value: any): void {
    this.limit = Number(value);
    this.count = 0;
    this.New_count = 0;
    this.fetchData();
  }

  // ── Helpers ────────────────────────────────────────────────────────────────
  DateFormat(value: any): string {
    return this.pipe.transform(value, 'MMM d, y') || '—';
  }

  calcDays(from: string, to: string): string {
    if (!from || !to) return '—';
    const diff = new Date(to).getTime() - new Date(from).getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24)) + 1;
    return days > 0 ? `${days}d` : '—';
  }

  getInitials(name: string): string {
    if (!name) return '?';
    return name.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
  }

  getStatusBadge(status: string): string {
    const map: Record<string, string> = {
      'Pending': 'lr-badge--requested',
      'Pre approved': 'lr-badge--preapproved',
      'Approved': 'lr-badge--approved',
      'Rejected': 'lr-badge--rejected',
    };
    return map[status] || '';
  }

  getStatusIcon(status: string): string {
    const map: Record<string, string> = {
      'Pending': 'fa-clock',
      'Pre approved': 'fa-thumbs-up',
      'Approved': 'fa-check-circle',
      'Rejected': 'fa-times-circle',
    };
    return map[status] || 'fa-circle';
  }

  getLeaveTypeBadge(type: string): string {
    const map: Record<string, string> = {
      'Sick Leave': 'lr-badge--sick',
      'Local Leave': 'lr-badge--local',
      'Vacation Leave': 'lr-badge--vacation',
      'Emergency Leave': 'lr-badge--emergency',
      'Official Trip': 'lr-badge--official',
      'Compassionate Leave': 'lr-badge--compassionate',
    };
    return map[type] || '';
  }
}